import React from "react";
import { useHistory } from "react-router-dom";
import { Button } from "@my-scoot/component-library-legacy";
import DvrIcon from "@material-ui/icons/Dvr";
import styles from "./CheckoutPageListing.module.css";
import {
  EXISTING_PAYMENT_LINKS_COLUMN_CONFIG,
  EXISTING_PAYMENT_LINKS_FILTER_CONFIG,
} from "features/PaymentLinks/modules/ExistingPaymentLinks/constants/ExistingPaymentLinks.constants";
import LinkField from "features/PaymentLinks/modules/ExistingPaymentLinks/components/LinkField/LinkField";
import Actions from "features/PaymentLinks/modules/ExistingPaymentLinks/components/Actions/Actions";
import StatusField from "features/PaymentLinks/modules/ExistingPaymentLinks/components/StatusField/StatusField";
import ExpireModal from "ui/pages/payments/DynamicLinkList/components/ExpireModal";
import CreatePaymentLinkModal from "features/PaymentLinks/modules/CreatePaymentLinkModal/CreatePaymentLinkModal";
import {
  notification_color_keys,
  useNotifications,
  useToggleState,
} from "utils/hooks";
import { useRefresh } from "react-admin";
import { is_empty } from "features/Common/utils/common.utils";
import { dataProvider } from "data";
import { PAYMENT_LINK_APIS } from "features/PaymentLinks/constants/PaymentLinks.apis";
import { getUserTimezone } from "utils/AuthUtil";
import moment from "moment";
import {
  PAYMENT_LINK_TRANSACTIONS_ROUTE_IDS,
  PAYMENT_LINKS_TRANSACTIONS_ROUTE_KEYS,
} from "features/PaymentLinks/modules/PaymentLinksTransactions/constants/PaymentLinksTransactions.constants";
import { existingPaymentLinksFilterChipsFormatter } from "features/PaymentLinks/modules/ExistingPaymentLinks/utils/ExistingPaymentLinks.utils";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";
import ExlyTable from "common/Components/ExlyTable";
import {
  checkout_page_listing_video,
  CHECKOUT_PAGE_TYPE_OPTIONS,
  checkout_update_route_key,
  CREATE_CHECKOUT_LINK_MODAL_TITLES,
} from "./CheckoutPageListing.constants";
import { apiMethods } from "data/api.constants";
import { isRequestSuccessful } from "utils/Utils";
import { logError } from "utils/error";
import { navigateTo } from "utils/urlUtils";
import { EXLY_TABLE_EMPTY_STATES_VERSIONS } from "common/Components/ExlyTable/ExlyTableEmptyState/constants/ExlyTableEmptyState.constants";
import { THANKYOU_PAGE_TYPES } from "ui/pages/ThankYou/constants/Thankyou.constants";
import { ThankYouBuilderChoiceModal } from "features/ThankYouPages/modules/ThankYouBuilderChoiceModal/ThankYouBuilderChoiceModal";
import { useDuplicatePaymentLink } from "features/PaymentLinks/modules/CreatePaymentLinkModal/utils/CreatePaymentLinkModal.apiCalls";
import { LazyLoadWrapper } from "features/Common/LazyLoadWrapper/LazyLoadWrapper";
import { ComboShareComboPopupLazyComponent } from "features/PaymentLinks/modules/ComboShareLinkModal/constants/ComboShareLinkModal.lazy";
import { useShareListingPopup } from "features/Listings/modules/ShareListingPopup/utils/useShareListingPopup";

const FilteredEmptyState = () => {
  return (
    <div className="text-center py-5 text-muted">
      <div>No checkout pages found!</div>
    </div>
  );
};

export const CheckoutPageListing = withComponentLibraryTheme((props) => {
  const { notify } = useNotifications();
  const refetch = useRefresh();
  const history = useHistory();
  const [showExpire, setShowExpire] = React.useState(false);
  const [isExpiringLink, startLinkExpire, stopLinkExpire] =
    useToggleState(false);
  const [selectedRecordData, setSelectedRecordData] = React.useState(null);
  const [editPaymentLinkModal, setEditPaymentLinkModal] = React.useState();
  const [openCreatePaymentLinkModal, setOpenCreatePaymentModal] =
    React.useState(false);
  const [comboSharePopupData, setComboSharePopupData] = React.useState(null);
  const [thankYouModalData, setThankYouModalData] = React.useState({
    open: false,
    listingUuid: null,
    paymentLinkUuid: null,
    isCombo: false,
  });

  const { openShareListingPopup, shareListingPopupOpen } =
    useShareListingPopup();

  const handleShareModalClose = () => {
    setComboSharePopupData(null);
  };

  const handleExpireAction = (record) => {
    setSelectedRecordData(record);
    setShowExpire(true);
  };

  const handleExpire = async (item) => {
    try {
      if (is_empty(item.dynamic_link_id)) return;
      startLinkExpire();
      const status = await dataProvider.custom_request(
        PAYMENT_LINK_APIS.update_payment_link,
        apiMethods.POST,
        {
          dynamic_link_id: item.dynamic_link_id,
          updated_values: {
            expiry_date: moment().tz(getUserTimezone()).toISOString(),
          },
        }
      );
      notify(status.message, notification_color_keys.info);
      if (isRequestSuccessful(status?.status)) {
        setShowExpire(false);
        refetch();
      }
    } catch (err) {
      logError({
        error: err,
        occuredAt:
          "src/features/CheckoutPages/modules/CheckoutPageListing/CheckoutPageListing.jsx",
        when: "handle expire function",
      });
      notify("Some error occured", notification_color_keys.error);
    } finally {
      stopLinkExpire();
    }
  };

  const handleCloseCreatePaymentLinkModal = () => {
    setOpenCreatePaymentModal(false);
  };

  const handleCreatePaymentLinkModal = () => {
    setOpenCreatePaymentModal(true);
  };

  const handleEditPaymentLink = (record) => {
    const handleClose = () => {
      setEditPaymentLinkModal();
    };

    setEditPaymentLinkModal(
      <CreatePaymentLinkModal
        record={record}
        open
        onClose={handleClose}
        createModalTitles={CREATE_CHECKOUT_LINK_MODAL_TITLES}
        linkTypeOptions={CHECKOUT_PAGE_TYPE_OPTIONS}
        editingModalTitle="Page Settings"
        modalConfig={{
          title: "Choose page type",
          pageLabel: "Page Name",
          priceLabel: "Page Price",
        }}
        isCheckoutPage
      />
    );
  };

  const handleRedirectToTransactions = () => {
    history.push(
      `/${
        PAYMENT_LINK_TRANSACTIONS_ROUTE_IDS[
          PAYMENT_LINKS_TRANSACTIONS_ROUTE_KEYS.PAYMENT_LINKS_TRANSACTIONS
        ]
      }`
    );
  };

  const handleRedirectToCheckoutPageEditDetails = (record) => {
    navigateTo(checkout_update_route_key, {
      args: {
        listingUuid: record?.listing_uuid,
        dynamicLinkUuid: record?.dynamic_link_id,
        isCheckout: true,
        isCombo: record?.is_combo ?? false,
      },
    });
  };

  const handleRedirectToThankYouPageEditDetails = (record) => {
    const isCombo = record?.is_combo ?? false;
    // Payment-link pages are independent of the listing's pages: always scope
    // the choice modal to the link itself when it has a dynamic_link_id.
    setThankYouModalData({
      open: true,
      listingUuid: record?.listing_uuid || null,
      paymentLinkUuid: record?.dynamic_link_id || null,
      isCombo,
    });
  };

  const { mutate: duplicatePaymentLink } = useDuplicatePaymentLink({
    onSuccess: (data) => {
      notify(
        "Payment link duplicated successfully",
        notification_color_keys.success
      );
      setComboSharePopupData(data);
      openShareListingPopup(true);
      refetch();
    },
  });

  const handleDuplicateCheckoutPage = (record) => {
    notify(`Duplicating ${record?.title}...`, notification_color_keys.info);
    duplicatePaymentLink({ dynamic_link_id: record?.dynamic_link_id });
  };

  const emptyListProps = {
    emptyStateProps: {
      version: EXLY_TABLE_EMPTY_STATES_VERSIONS.V2,
      title: "Create a checkout page",
      description: "As soon as we have new payment, it will show up here.",
      videoSrc: checkout_page_listing_video,
      primaryCtaProps: {
        title: "Create checkout pages",
        onClick: handleCreatePaymentLinkModal,
      },
    },
  };

  return (
    <>
      <ExlyTable
        ra_props={{
          ...props,
        }}
        noExportButton
        tableTitle={<>Manage Checkout Pages</>}
        filteredEmoptyState={<FilteredEmptyState />}
        columnConfig={EXISTING_PAYMENT_LINKS_COLUMN_CONFIG}
        tableFilters={EXISTING_PAYMENT_LINKS_FILTER_CONFIG}
        tableChipsFormatter={existingPaymentLinksFilterChipsFormatter}
        layoutProps={{
          paddingDesktop: "0",
          paddingBottom: "120px",
          layoutDesktopMargin: "20px 24px",
          noMobileBoxShadow: true,
          showBackCta: false,
          secondaryComponent: (
            <div className={styles.transactionsCtaContainer}>
              <Button
                startIcon={<DvrIcon />}
                onClick={handleRedirectToTransactions}
              >
                See transactions
              </Button>
              <Button onClick={handleCreatePaymentLinkModal}>
                Create a Checkout Page
              </Button>
            </div>
          ),
        }}
        primaryKey="id"
        borderedFields
        fieldsLeftPadded
        fieldsAlignment="space-between"
        drawerFieldsBordered
        drawerFieldsAlignment="space-between"
        recordFooterVariant="secondary"
        renderSecondaryAction={(record) => <LinkField record={record} />}
        customPrimaryAction={{
          renderCustomAction: (record) => (
            <Actions
              record={record}
              onExpire={handleExpireAction}
              onEdit={handleEditPaymentLink}
              onEditCheckout={handleRedirectToCheckoutPageEditDetails}
              onEditThankYouPage={handleRedirectToThankYouPageEditDetails}
              actionKey="Page"
              onDuplicate={handleDuplicateCheckoutPage}
            />
          ),
        }}
        renderPrimaryColumnRightNode={(record) => (
          <StatusField record={record} />
        )}
        desktopCustomPrimaryAction={{
          renderCustomAction: (record) => (
            <Actions
              record={record}
              onExpire={handleExpireAction}
              onEdit={handleEditPaymentLink}
              onEditCheckout={handleRedirectToCheckoutPageEditDetails}
              onEditThankYouPage={handleRedirectToThankYouPageEditDetails}
              actionKey="Page"
              onDuplicate={handleDuplicateCheckoutPage}
            />
          ),
        }}
        primaryColumnProps={{
          align: "center",
          sticky: true,
          width: "90px",
        }}
        hasMobileFooter
        footerProps={{
          primarybtn: "Transactions",
          primaryClick: handleRedirectToTransactions,
          hidePrimarybtn: false,
          // primaryBtnProps: { startIcon: <DvrIcon /> },
          hideSecondaryBtn: false,
          secondaryBtnColor: "primary",
          secondaryBtn: "Create a Checkout Page",
          secondaryClick: handleCreatePaymentLinkModal,
          classes: {
            footer: styles.footerStyles,
          },
        }}
        {...emptyListProps}
      />
      <ExpireModal
        open={showExpire}
        onClose={() => setShowExpire(false)}
        onPrimaryBtnClick={() => handleExpire(selectedRecordData)}
        onSecondaryBtnClick={() => setShowExpire(false)}
        isExpiringLink={isExpiringLink}
      />

      {editPaymentLinkModal}
      <CreatePaymentLinkModal
        open={openCreatePaymentLinkModal}
        onClose={handleCloseCreatePaymentLinkModal}
        shouldRefetchOnPaymentLinkGeneration
        createModalTitles={CREATE_CHECKOUT_LINK_MODAL_TITLES}
        linkTypeOptions={CHECKOUT_PAGE_TYPE_OPTIONS}
        editingModalTitle="Page Settings"
        modalConfig={{
          title: "Choose page type",
          pageLabel: "Page Name",
          priceLabel: "Page Price",
        }}
        isCheckoutPage
      />

      {comboSharePopupData && (
        <LazyLoadWrapper loadingCondition={shareListingPopupOpen}>
          {/* If COMBO type Payment Link */}
          <ComboShareComboPopupLazyComponent
            comboTitle={comboSharePopupData?.title}
            onClose={handleShareModalClose}
            dynamicLinkUuid={comboSharePopupData?.dynamic_link_id}
            shareLink={comboSharePopupData?.pricing_link}
            hideOfferingToast
            hideNextDetails
            offeringData={{
              cover_image: comboSharePopupData?.cover_image,
              metadata: {
                share_url: comboSharePopupData?.pricing_link,
              },
            }}
            hideCheckoutUrl
            copyListingPageCTAText="Copy Link"
            showCopyIcon
            showPaymentPageButton
          />
        </LazyLoadWrapper>
      )}

      <ThankYouBuilderChoiceModal
        open={thankYouModalData.open}
        onClose={() =>
          setThankYouModalData({
            open: false,
            listingUuid: null,
            paymentLinkUuid: null,
            isCombo: false,
          })
        }
        listingUuid={thankYouModalData.listingUuid}
        paymentLinkUuid={thankYouModalData.paymentLinkUuid}
        isCombo={thankYouModalData.isCombo}
        pageType={THANKYOU_PAGE_TYPES.PURCHASE.key}
      />
    </>
  );
});
